import axios from 'axios'
import { Dialog } from 'cube-ui'
import { initSign, getSign } from '@didi/wsgsig'
import URL from 'common-js/util/url'
import qs from 'qs'

const pathname = location && location.pathname || ''
const NAME_IDENTITY = 'name-identity'
const AUTH_BANK_REALNAME = 'auth-bank-realname'

const handleError = (lang) => {
  const langVal = (lang || 'zh-cn').toLocaleLowerCase()
  const localMap = {
    'zh-cn': '网络请求超时！',
    'en-us': 'Network error'
  }
  if (!pathname.includes(NAME_IDENTITY) && !pathname.includes(AUTH_BANK_REALNAME)) {
    Dialog.$create({
      type: 'alert',
      content: localMap[langVal] || localMap['zh-cn'],
      icon: 'cubeic-important',
    }).show()
  }
}

/**
初始化安全SDK，一般在入口文件初始化
bizId: 联系 冯威fengweihuaer 分配
env: test：测试环境；  CN：国内环境；（网约车、花小猪、鸿鹄）  RUS：俄罗斯；  AME：美东;   SOFI：金融专用；  G：不明地区时候默认域名；
appVer: 业务方自定义，方便问题排查时定位版本tag
os: '1' -- 微信小程序  '2 -- 支付宝小程序  '3' -- 滴滴小程序  '4' -- 浏览器H5、PC(全局变量为window)  '5'-- 全局变量非window，甚至不知道全局变量是什么  '0' -- 其他  0/5 联系@冯威 确认下
domainList: 接入挑战应答能力需要传入该参数，参数值为请求的后端接口域名  ['www.didiglobal.com', 'www.xiaojukeji.com']
byQuery: 配置true，挑战引导header信息通过query参数携带；默认是false就会增加额外的header参数，会有接口跨域问题，通过query传递避免跨域
httpEnable: 挑战应答只支持https协议，因此请保证应用在任何环境下都使用https协议。线下测试环境确实无法开启https支持，需要对http进行加白，联系朱亚博
**/

function initHttp({bizId, env, os, appVer, domainList}) {
  initSign({
    bizId: bizId || '', // 联系 冯威fengweihuaer 分配
    env: env || 'CN',
    os: os || '4',
    appVer: appVer || '',
    domainList: domainList, // 请求后端的域名
    byQuery: true, // 挑战应答
    httpEnable: false
  })
}

function appendSign({type, url, params, headers}) {
  let wsgsig
  try {
    if (type === 'post') {
      wsgsig = getSign({
        body: params,
        contentType: (headers && headers['Content-Type']) || 'application/x-www-form-urlencoded'
      })
      console.log('post', url, params, wsgsig)
    } else {
      wsgsig = getSign({
        params
      })
      console.log('get', url, params, wsgsig)
    }
  } catch (e) {
    console.error(e, '---获取签名报错---', wsgsig)
  }
  return URL.stringify(url, {
    wsgsig, // 签名参数
  })
}

function fetchGet({url, params, lang}) {
  const filterParam = URL.filterObject(params)
  return new Promise((resolve, reject) => {
    axios.get(appendSign({type: 'get', url, params: filterParam}), {
      params: filterParam
    })
      .then(response => {
        resolve(response.data)
      })
      .catch((error) => {
        handleError(lang)
        reject(error)
      })
  })
}

function fetchPost({url, data, flag = false, token, lang, headers}) {
  const filterParam = URL.filterObject(data)
  return new Promise((resolve, reject) => {
    if (token !== undefined) {
      url = url + '?token=' + token + '&lang=' + lang
    }
    axios.request({
      url: appendSign({type: 'post', url, params: filterParam, headers}),
      method: 'post',
      emulateJSON: !flag,
      data: qs.stringify(filterParam),
      headers
    }).then(response => {
      resolve(response.data)
    })
    .catch((error) => {
      handleError(lang)
      reject(error)
    })
  })
}

export {
  initHttp,
  fetchGet,
  fetchPost,
  appendSign
}
